<template>
	<div>
		<v-toolbar flat class="sticky-top" color="primary" dark>
			<v-container>
				<v-row align="center">
					<v-col cols="auto">
						<v-toolbar-title>{{ $t('SmartNavBar.My_invoices') }}</v-toolbar-title>
					</v-col>
					<v-spacer />
					<v-col cols="auto">
						<v-autocomplete :items="invoiceIds" v-model="invoiceId" class="my-auto"
							:placeholder="$t('Invoice_number')" flat dense outlined background-color="transparent" hide-details clearable
							@change="onSearch" @click:clear="onClear" style="max-width: 250px"></v-autocomplete>
					</v-col>
				</v-row>
			</v-container>
		</v-toolbar>

		<v-container>
			<v-row justify="center" v-for="invoice of invoiceList">
				<v-col cols="12">
					<InvoiceCard :faktuurh="invoice"  :key="invoice.RowIdent" />
				</v-col>
			</v-row>
			<v-row justify="center">
				<v-btn class="my-3" v-if="this.rowIdent" :loading="loading" color="primary" @click="getInvoiceList()">
					<span class="mx-4">{{ $t('Load_more') }}</span>
				</v-btn>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import caas from "@/services/caas";
import InvoiceCard from "../components/InvoiceCard";
export default {
	name: "SalesInvoices",
	components: { InvoiceCard },

	data() {
		return {
			loading: false,
			tabId: 0,
			invoiceList: [],
			rowsToBatch: 10,
			rowNum: 0,
			rowIdent: "",
			invoiceId: 0,
			invoiceIds: []
		};
	},

	created() {
		caas
			.rpc("getPortalUserInvoiceIds", {})
			.then((response) => {
				this.invoiceIds = response.data.success.invoiceIds
			})
			.catch((error) => {
				console.log(error.message);
				this.loading = false
			})
	},

	methods: {
		getInvoiceList() {
			this.loading = true;
			let params = {
				year: 0,
				invoiceId: this.invoiceId || 0,
				rowNum: this.rowNum,
				rowIdent: this.rowIdent,
				rowsToBatch: this.rowsToBatch,
			};
			caas
				.rpc("getPortalUserInvoices", params)
				.then((response) => {
					if (response.data.success.data) {
						this.invoiceList.push(
							...response.data.success.data.invoiceList.invoice
						);
						this.rowNum = response.data.success.rowNum;
						this.rowIdent = response.data.success.rowIdent;
						this.loading = false
					} else if (response.data.success.error) {
						throw response.data.success.error;
					}
				})
				.catch((error) => {
					console.log(error.message);
					this.loading = false
				})
		},
		onClear() {
			this.invoiceId = 0;
			this.onSearch();
		},
		onSearch() {
			this.invoiceList = [];
			this.rowNum = 0;
			this.rowIdent = "";
			this.getInvoiceList();
		},
	},
	mounted() {
		this.getInvoiceList();
	},
};
</script>
